(function () {
  "use strict";

  var container = document.getElementById("search-results");
  if (!container) return;

  var searchType = container.dataset.searchType;

  function sanitizeText(text) {
    const el = document.createElement('div')
    el.innerText = text
    return el.innerHTML
  }

  function initShowMore() {
    container.querySelectorAll("[data-show-more]:not([data-initialized])").forEach(function (btn) {
      btn.setAttribute("data-initialized", "");
      btn.addEventListener("click", function () {
        var type = btn.dataset.showMore;
        var batchSize = parseInt(btn.dataset.batchSize, 10);
        var total = parseInt(btn.dataset.total, 10);
        var shown = parseInt(btn.dataset.shown, 10);

        var grid = container.querySelector('[data-grid="' + type + '"]');
        if (!grid) return;

        var hiddenItems = grid.querySelectorAll("[data-hidden-item].hidden");
        var toReveal = Math.min(batchSize, hiddenItems.length);

        for (var i = 0; i < toReveal; i++) {
          hiddenItems[i].classList.remove("hidden");
        }

        var newShown = shown + toReveal;
        btn.dataset.shown = newShown.toString();

        if (newShown >= total) {
          btn.remove();
        }
      });
    });
  }

  var isLoadingMore = false;
  var scrollObserver = null;

  function getSectionId() {
    return container.dataset.sectionId;
  }

  async function fetchSection(url) {
    var sectionId = getSectionId();
    if (!sectionId) return null;

    var separator = url.includes("?") ? "&" : "?";
    var fetchUrl = url + separator + "section_id=" + sectionId;

    var res = await fetch(fetchUrl);
    if (!res.ok) throw new Error("Section fetch failed: " + res.status);

    var html = await res.text();
    var doc = new DOMParser().parseFromString(html, "text/html");
    return doc.getElementById("search-results");
  }

  function initInfiniteScroll() {
    var sentinel = document.getElementById("load-more-sentinel");
    if (!sentinel) return;

    if (scrollObserver) scrollObserver.disconnect();

    scrollObserver = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        if (entry.isIntersecting && !isLoadingMore) {
          loadNextPage(entry.target);
        }
      },
      { rootMargin: "0px 0px 400px 0px" }
    );

    scrollObserver.observe(sentinel);
  }

  async function loadNextPage(sentinel) {
    var nextUrl = sentinel.dataset.nextUrl;
    if (!nextUrl || isLoadingMore) return;

    isLoadingMore = true;

    try {
      var newContent = await fetchSection(nextUrl);
      if (!newContent) return;

      var gridId = searchType === "product" ? "product-grid" : "article-grid";
      var newGrid = newContent.querySelector("#" + gridId);
      var currentGrid = document.getElementById(gridId);

      if (newGrid && currentGrid) {
        while (newGrid.firstChild) {
          currentGrid.appendChild(newGrid.firstChild);
        }
      }

      var newSentinel = newContent.querySelector("#load-more-sentinel");
      if (newSentinel) {
        sentinel.dataset.nextUrl = newSentinel.dataset.nextUrl;
        scrollObserver.observe(sentinel);
      } else {
        sentinel.remove();
      }
    } catch (e) {
      if (e.name === "AbortError") return;
      sentinel.remove();
    } finally {
      isLoadingMore = false;
    }
  }

  var searchQuery = new URLSearchParams(window.location.search).get("q") || "";
  var storageKey = "search_counts:" + searchQuery.toLowerCase().trim();
  var titleStorageKey = "search_title:" + searchQuery.toLowerCase().trim();

  function saveTabCounts() {
    var counts = {};
    document.querySelectorAll(".search-tab[data-tab-type]").forEach(function (tab) {
      var span = tab.querySelector(".text-gray-mid");
      if (span && span.textContent.trim()) {
        counts[tab.dataset.tabType] = span.textContent.trim();
      }
    });
    try { sessionStorage.setItem(storageKey, JSON.stringify(counts)); } catch (e) {}
  }

  function saveTotalCount() {
    var heading = document.querySelector("[data-search-total]");
    if (!heading) return;
    var total = heading.dataset.searchTotal;
    if (total) {
      try { sessionStorage.setItem(titleStorageKey, total); } catch (e) {}
    }
  }

  function restoreTotalCount() {
    var heading = document.querySelector("[data-search-title]");
    if (!heading) return;
    try {
      var total = sessionStorage.getItem(titleStorageKey);
      if (!total) return;
      var termEl = heading.querySelector(".search-term");
      var terms = termEl ? sanitizeText(termEl.textContent) : "";
      heading.innerHTML = total + ' results for "<span class=\'search-term\'>' + terms + '</span>"';
    } catch (e) {}
  }

  function restoreTabCounts() {
    try {
      var raw = sessionStorage.getItem(storageKey);
      if (!raw) return false;
      var counts = JSON.parse(raw);
      var restored = false;
      Object.keys(counts).forEach(function (type) {
        var tab = document.querySelector('.search-tab[data-tab-type="' + type + '"]');
        if (!tab) return;
        var span = tab.querySelector(".text-gray-mid");
        if (span) {
          span.textContent = counts[type];
          restored = true;
        }
        if (type !== "all") {
          var match = counts[type].match(/\((\d+)\)/);
          tab.hidden = match && parseInt(match[1], 10) === 0;
        }
      });
      return restored;
    } catch (e) {
      return false;
    }
  }

  function revealCounts() {
    var nav = document.querySelector(".search-tabs");
    if (nav) nav.classList.add("counts-ready");
  }

  function updateTabCount(type, count) {
    var tab = document.querySelector('.search-tab[data-tab-type="' + type + '"]');
    if (!tab) return;
    var countSpan = tab.querySelector(".text-gray-mid");
    if (countSpan) {
      countSpan.textContent = "(" + count + ")";
    }
    if (type !== "all") {
      tab.hidden = count === 0;
    }
  }

  function updateAllTabCount() {
    var total = 0;
    ["products", "articles", "pages"].forEach(function (type) {
      var tab = document.querySelector('.search-tab[data-tab-type="' + type + '"]');
      if (!tab) return;
      var span = tab.querySelector(".text-gray-mid");
      if (!span) return;
      var match = span.textContent.match(/\((\d+)\)/);
      if (match) total += parseInt(match[1], 10);
    });
    updateTabCount("all", total);
    var heading = document.querySelector("[data-search-total]");
    if (heading) {
      var termEl = heading.querySelector(".search-term");
      var terms = termEl ? sanitizeText(termEl.textContent) : "";
      heading.innerHTML = total + ' results for "<span class=\'search-term\'>' + terms + '</span>"';
      heading.dataset.searchTotal = total.toString();
    }
  }

  async function fetchArticlesForAllTab() {
    var articlesUrl = container.dataset.articlesUrl;
    if (!articlesUrl) return;

    var contentPerPage = parseInt(container.dataset.contentPerPage, 10) || 4;
    var sectionId = getSectionId();
    if (!sectionId) return;

    var pagesPromise = fetchPagesCountForAllTab();

    try {
      var separator = articlesUrl.includes("?") ? "&" : "?";
      var fetchUrl = articlesUrl + separator + "section_id=" + sectionId;
      var res = await fetch(fetchUrl);
      if (!res.ok) return;

      var html = await res.text();
      var doc = new DOMParser().parseFromString(html, "text/html");
      var fetchedResults = doc.getElementById("search-results");
      if (!fetchedResults) return;

      var fetchedGrid = fetchedResults.querySelector("#article-grid");
      var articlesCount = parseInt(fetchedResults.dataset.resultsCount, 10) || 0;

      var articlesSection = container.querySelector('[data-search-section="articles"]');
      var articlesGrid = container.querySelector('[data-grid="articles"]');

      if (!articlesSection || !articlesGrid) return;

      if (!fetchedGrid || fetchedGrid.children.length === 0) {
        articlesSection.classList.add("hidden");
        updateTabCount("articles", 0);
        return;
      }

      articlesSection.classList.remove("hidden");
      articlesGrid.innerHTML = "";

      var items = Array.from(fetchedGrid.children);
      items.forEach(function (item, index) {
        var li = item.cloneNode(true);
        if (index >= contentPerPage) {
          li.classList.add("hidden");
          li.setAttribute("data-hidden-item", "");
        } else {
          li.classList.remove("hidden");
          li.removeAttribute("data-hidden-item");
        }
        articlesGrid.appendChild(li);
      });

      var existingBtnWrap = articlesSection.querySelector("[data-show-more='articles']");
      if (existingBtnWrap) {
        existingBtnWrap.closest(".mt-10").remove();
      }

      if (items.length > contentPerPage) {
        var btnContainer = document.createElement("div");
        btnContainer.className = "mt-10 text-center";
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "button button--secondary";
        btn.setAttribute("data-show-more", "articles");
        btn.setAttribute("data-batch-size", contentPerPage.toString());
        btn.setAttribute("data-total", items.length.toString());
        btn.setAttribute("data-shown", contentPerPage.toString());
        btn.textContent = "Show more Content";
        btnContainer.appendChild(btn);
        articlesGrid.after(btnContainer);
        initShowMore();
      }

      updateTabCount("articles", articlesCount);
    } catch (e) {
    } finally {
      await pagesPromise;
      updateAllTabCount();
      revealCounts();
      saveTotalCount();
      saveTabCounts();
    }
  }

  async function fetchPagesCountForAllTab() {
    var pagesUrl = container.dataset.pagesUrl;
    if (!pagesUrl) return;

    var sectionId = getSectionId();
    if (!sectionId) return;

    try {
      var separator = pagesUrl.includes("?") ? "&" : "?";
      var fetchUrl = pagesUrl + separator + "section_id=" + sectionId;
      var res = await fetch(fetchUrl);
      if (!res.ok) return;

      var html = await res.text();
      var doc = new DOMParser().parseFromString(html, "text/html");
      var fetchedResults = doc.getElementById("search-results");
      if (!fetchedResults) return;

      var pagesSection = container.querySelector('[data-search-section="pages"]');

      var fetchedList = fetchedResults.querySelector(".search-pages-list");
      var pagesCount = fetchedList ? fetchedList.children.length : 0;
      updateTabCount("pages", pagesCount);

      if (!pagesSection) return;

      if (pagesCount === 0) {
        pagesSection.classList.add("hidden");
        return;
      }

      pagesSection.classList.remove("hidden");
      var localList = pagesSection.querySelector('[data-grid="pages"]');
      if (localList) {
        localList.innerHTML = "";
        while (fetchedList.firstChild) {
          localList.appendChild(fetchedList.firstChild);
        }
      }
    } catch (e) {
    }
  }

  async function fetchTabCounts() {
    if (restoreTabCounts()) {
      var serverCount = container.dataset.resultsCount;
      if (serverCount) {
        var activeType = searchType === "product" ? "products" : searchType === "article" ? "articles" : searchType === "page" ? "pages" : null;
        if (activeType) updateTabCount(activeType, parseInt(serverCount, 10));
        saveTabCounts();
      }
      revealCounts();
      return;
    }

    var sectionId = getSectionId();
    if (!sectionId) return;

    var activeTabType = searchType === "product" ? "products" : searchType === "article" ? "articles" : searchType === "page" ? "pages" : null;
    if (activeTabType) {
      updateTabCount(activeTabType, parseInt(container.dataset.resultsCount, 10) || 0);
    }

    var typesToFetch = ["products", "articles", "pages"].filter(function (t) { return t !== activeTabType; });

    await Promise.all(typesToFetch.map(function (type) {
      var tab = document.querySelector('.search-tab[data-tab-type="' + type + '"]');
      if (!tab) return Promise.resolve();
      var url = tab.getAttribute("href");
      if (!url) return Promise.resolve();
      var separator = url.includes("?") ? "&" : "?";
      return fetch(url + separator + "section_id=" + sectionId).then(function (res) {
        if (!res.ok) return;
        return res.text();
      }).then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, "text/html");
        var results = doc.getElementById("search-results");
        if (!results) return;
        updateTabCount(type, parseInt(results.dataset.resultsCount, 10) || 0);
      }).catch(function () {});
    }));

    var total = 0;
    ["products", "articles", "pages"].forEach(function (type) {
      var tab = document.querySelector('.search-tab[data-tab-type="' + type + '"]');
      if (!tab) return;
      var span = tab.querySelector(".text-gray-mid");
      if (!span) return;
      var match = span.textContent.match(/\((\d+)\)/);
      if (match) total += parseInt(match[1], 10);
    });
    updateTabCount("all", total);

    var heading = document.querySelector("[data-search-title]");
    if (heading) {
      var termEl = heading.querySelector(".search-term");
      var terms = termEl ? sanitizeText(termEl.textContent) : "";
      heading.innerHTML = total + ' results for "<span class=\'search-term\'>' + terms + '</span>"';
    }

    revealCounts();
    saveTabCounts();
    try { sessionStorage.setItem(titleStorageKey, total.toString()); } catch (e) {}
  }

  if (searchType === "all") {
    var productsCount = parseInt(container.dataset.productsCount, 10) || 0;
    updateTabCount("products", productsCount);
    saveTotalCount();
    initShowMore();
    fetchArticlesForAllTab();
  } else if (searchType === "product" || searchType === "article") {
    restoreTotalCount();
    initInfiniteScroll();
    if (searchType === "article" && (searchQuery.toLowerCase().includes("rolex") || searchQuery.toLowerCase().includes("cartier"))) {
      var articleCount = parseInt(container.dataset.resultsCount, 10) || 0;
      updateTabCount("articles", articleCount);
      ["all", "products", "pages"].forEach(function (type) {
        var tab = document.querySelector('.search-tab[data-tab-type="' + type + '"]');
        if (tab) tab.hidden = true;
      });
      var nav = document.querySelector(".search-tabs");
      if (nav) nav.classList.add("search-tabs--single");
      var heading = document.querySelector("[data-search-title]");
      if (heading) {
        var termEl = heading.querySelector(".search-term");
        var terms = termEl ? sanitizeText(termEl.textContent) : "";
        heading.innerHTML = articleCount + ' results for "<span class=\'search-term\'>' + terms + '</span>"';
      }
      revealCounts();
    } else {
      fetchTabCounts();
    }
  } else if (searchType === "page") {
    var pageCount = parseInt(container.dataset.resultsCount, 10) || 0;
    if (pageCount === 0) {
      var allUrl = container.dataset.allUrl;
      if (allUrl) {
        window.location.replace(allUrl);
        return;
      }
    }
    restoreTotalCount();
    fetchTabCounts();
  }
})();
